import { TextKey } from '@mews-commander/enums';
import { useLocalizeText } from '@mews/framework';
import { getAppConfiguration } from '@mews-commander/data-access';
import { PlatformEnvironment } from '@mews/enums';
import { isCurrentProfilePlatformAdmin } from '@mews-commander/legacy-entities/src/selectors/session/scope';

const guestExperienceMailTypeTextKeyMap: Record<string, Mews.TextKey> = {
    AutomaticSettlementFailure: TextKey.GuestExperienceMailTypeAutomaticSettlementFailure,
    BillSent: TextKey.GuestExperienceMailTypeBillSent,
    BookingAbandoned: TextKey.GuestExperienceMailTypeBookingAbandoned,
    BookerReservationConfirmation: TextKey.GuestExperienceMailTypeBookerReservationConfirmation,
    BeforeStartReminder: TextKey.GuestExperienceMailTypeBeforeStartReminder,
    BeforeStart: TextKey.GuestExperienceMailTypeBeforeStart,
    AfterStart: TextKey.GuestExperienceMailTypeAfterStart,
    AfterEnd: TextKey.GuestExperienceMailTypeAfterEnd,
    ReleaseReminder: TextKey.GuestExperienceMailTypeReleaseReminder,
    ChargeFailure: TextKey.GuestExperienceMailTypeChargeFailure,
    ChargePreauthorizationSuccess: TextKey.GuestExperienceMailTypeChargePreauthorizationSuccess,
    ChargeSuccess: TextKey.GuestExperienceMailTypeChargeSuccess,
    CompanionInvitation: TextKey.GuestExperienceMailTypeCompanionInvitation,
    GuestEmailVerified: TextKey.GuestExperienceMailTypeGuestEmailVerified,
    OnlineCheckInInvitation: TextKey.GuestExperienceMailTypeOnlineCheckInInvitation,
    OnlineCheckOutInvitation: TextKey.GuestExperienceMailTypeOnlineCheckOutInvitation,
    PaymentAuthorization: TextKey.GuestExperienceMailTypePaymentAuthorization,
    PaymentAuthorizationFailure: TextKey.GuestExperienceMailTypePaymentAuthorizationFailure,
    PaymentRequestAdded: TextKey.GuestExperienceMailTypePaymentRequestAdded,
    ReservationCancellation: TextKey.GuestExperienceMailTypeReservationCancellation,
    ReservationConfirmation: TextKey.GuestExperienceMailTypeReservationConfirmation,
    ReservationQuotation: TextKey.GuestExperienceMailTypeReservationQuotation,
    SignInLink: TextKey.GuestExperienceMailTypeSignInLink,
    UnreadMessageNotification: TextKey.GuestExperienceMailTypeUnreadMessageNotification,
    VerificationCode: TextKey.GuestExperienceMailTypeVerificationCode,
};

export const getMailTypeTextKey = (mailType: string): Mews.TextKey | null =>
    guestExperienceMailTypeTextKeyMap[mailType] ?? null;

interface GetLocalizedMailTypesProps {
    emailTypes: string[];
    localizeText: ReturnType<typeof useLocalizeText>;
}

export const getLocalizedMailTypes = ({ emailTypes, localizeText }: GetLocalizedMailTypesProps) =>
    emailTypes.map((mailType) => {
        const mailTypeTextKey = getMailTypeTextKey(mailType);
        return mailTypeTextKey != null ? localizeText({ textKey: mailTypeTextKey }) : mailType;
    });

export const isAllowedAccessEmailWhitelistingRoutes = () =>
    getAppConfiguration().environment !== PlatformEnvironment.Production && isCurrentProfilePlatformAdmin();
